export default {
    DebounceDelay: 300,
    NoOfRowsAtATime: 25,
    MinutesPerDrop: 20
};
